import urlJoin from 'url-join'
import {getCurrentBaseUrl} from '@@client/lib/url'

// this is really only used for cancelling an order
const storageKey = 'wkr:affirm-order-id'

export const saveAffirmOrderId = (orderId) => {
    localStorage.setItem(storageKey, orderId)
}

export const getAffirmOrderId = () => {
    return localStorage.getItem(storageKey)
}

export const clearAffirmOrderId = () => {
    localStorage.removeItem(storageKey)
}

export const getAffirmReturnUrl = () => {
    return urlJoin(getCurrentBaseUrl(), '/affirm')
}

export const getAffirmCancelUrl = () => {
    return urlJoin(getCurrentBaseUrl(), '/affirm/cancel')
}
